import { render, staticRenderFns } from "./LocalMedia.vue?vue&type=template&id=b4878bc4&scoped=true&"
import script from "./LocalMedia.vue?vue&type=script&lang=js&"
export * from "./LocalMedia.vue?vue&type=script&lang=js&"
import style0 from "./LocalMedia.vue?vue&type=style&index=0&id=b4878bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4878bc4",
  null
  
)

export default component.exports